import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { DateTime } from 'luxon';

@Component({
    selector: 'app-prints',
    templateUrl: './prints.component.html',
    styleUrls: ['./prints.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PrintsComponent implements OnInit {
  images$ = new BehaviorSubject([]);
  size = document.body.offsetWidth;
  currentIndex$ = new BehaviorSubject(0);

  constructor(private domSanitizer: DomSanitizer) {}

  ngOnInit(): void {
    this.images$.subscribe((images) => {});
  }

  loaded(ev) {
    console.log(ev.target.naturalWidth, ev.target.naturalHeight);
    URL.revokeObjectURL(ev.target.src);
  }

  async picked(ev) {
    const files = [...ev.target.files];
    this.images$.next(files);
    const time = DateTime.now();
    for (const file of files) {
      this.currentIndex$.next(files.indexOf(file));
      console.log(file);
      const image = await createImageBitmap(file);
      console.log(image.width);
      image.close();
    }
    alert(DateTime.now().diff(time).toFormat('mm:ss'));
  }
}
